import { X } from '@mui/icons-material';
import { Autocomplete, Box, FormControl, FormHelperText, FormLabel, MenuItem, TextField } from '@mui/material';
import * as React from 'react';


export default function CustomAutocomplete({ values, onChange, error, data, title, required, disabled, labelName, valueName, placeholder, includeInputInList, freeSolo, style }) {

    return (
        <>
            <FormControl variant="outlined" fullWidth>
                <FormLabel style={{ fontFamily: 'Manrope-SemiBold', fontSize: 14 }}>{title}{required && <span style={{ color: "red" }}>*</span>}</FormLabel>
                <Autocomplete
                    size="small"
                    value={data.find(option => option?.[valueName] === values) || null}
                    required={required}
                    disabled={disabled}
                    options={data}
                    freSolo
                    getOptionLabel={(option, value) => option?.[labelName] || values}
                    renderOption={(props, option) => (
                        <Box component="li" {...props} key={`${option.identity}`} style={{ backgroundColor: values === option?.[valueName] ? "#fef3f5" : "white", color: values === option?.[valueName] ? '#44d62c' : '#101010'}}>
                            {option?.[labelName]}
                        </Box>
                    )}
                    isOptionEqualToValue={(option, value) => option?.[valueName] === value?.[valueName]} // Match by valueName
                    placeholder={placeholder}
                    onChange={(e, value) => onChange(e, value)}
                    popupIcon={<i className="ri-expand-up-down-line" style={{ color: '#101010' }} />}
                    renderInput={(params) =>
                        <TextField {...params} placeholder={placeholder}
                            sx={{ width: "100%" }}

                        />
                    }
                    sx={style}>
                </Autocomplete>
            </FormControl>
            {error && <FormHelperText sx={{ color: "red" }}>{error || ""}</FormHelperText>}

        </>


    );
}
